import styled from 'styled-components';
import { COLOR, FONT_SIZE, SPACING } from '../../../constants/theme';

export const CancelPrompt = styled.p`
  margin: ${SPACING.lg} 0 0;
  font-size: ${FONT_SIZE.hint};
  text-align: center;
  color: ${COLOR.textSecondary};
`;

export const CancelLink = styled.button`
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  font-size: inherit;
  color: ${COLOR.primary};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${COLOR.primaryDark};
  }
`;
